/*--------------------------------------------------------------
# Custom scripts for card slider - used in related posts and card carousel
--------------------------------------------------------------*/

const cardSlider = document.querySelectorAll('.card-slider .swiper-news-events');
const cardSliderNext = document.querySelectorAll('.card-swiper-next');
const cardSliderPrev = document.querySelectorAll('.card-swiper-prev');

for( i = 0; i < cardSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    cardSlider[i].classList.add('swiper-' + i);
    cardSliderNext[i].classList.add('card-swiper-next-' + i);
    cardSliderPrev[i].classList.add('card-swiper-prev-' + i);

    var initCardSlider = new Swiper('.card-slider .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-' + i,
            prevEl: '.card-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            }
        }
    });
}

const peopleSlider = document.querySelectorAll('.card-slider .swiper-people');
const peopleSliderNext = document.querySelectorAll('.card-swiper-next');
const peopleSliderPrev = document.querySelectorAll('.card-swiper-prev');

for( i = 0; i < peopleSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    peopleSlider[i].classList.add('swiper-' + i);
    peopleSliderNext[i].classList.add('card-swiper-next-' + i);
    peopleSliderPrev[i].classList.add('card-swiper-prev-' + i);

    var initPeopleSlider = new Swiper('.card-slider .swiper-' + i, {
        simulateTouch: false,
        grabCursor: false,
        slidesPerView: 1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.card-swiper-next-' + i,
            prevEl: '.card-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            }
        }
    });
}

